export default "__VITE_ASSET__CVKtYBS7__"